import { Link } from "react-router-dom";
import { blogPosts } from "../data";
import { localizeBody } from "../i18n.js";
import read from "../utils/readTime.mjs";

export default function PostRow({ root, label, title, path, isFirst, link, subtitle, t, copy, language }) {
  const Component = link ? Link : "div";
  const header = root && path ? `/${root}/${path}` : "";
  const blogBody = root === "blog" && path ? localizeBody(blogPosts[path], language) : null;
  const time = blogBody ? read.getReadingTime(blogBody, copy?.minRead) : null;

  return ( 
    <Component
      to={link ? header : undefined}
      className="post-row"
      style={{
        display: "flex",
        flexDirection: "column", 
        gap: 4,                
        padding: "14px 0",
        borderBottom: `1px solid ${t.borderLight}`,
        borderTop: isFirst ? `1px solid ${t.borderLight}` : undefined,
        textDecoration: "none",
        color: "inherit",
        cursor: link ? "pointer" : "default",
      }}
    >
      <span
        style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 12,
          color: t.dim,
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </span>

      <span
        className="post-row-title"
        style={{ fontSize: 16, color: t.text, transition: "color 0.15s" }}
      >
        {title}
      </span>
      {time && (
        <span
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 12,
            color: t.dim,
          }}
        >
          {time}
        </span>
     )}

      {subtitle && (
        <span
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 12,
            color: t.dim,
          }}
        >
          {subtitle}
        </span>
      )}
    </Component>
  );
}
